import styled from "styled-components";

export const ContainerBloco = styled.div`
    width: 100%;
    border-radius: 6px;
    padding: 24px;
    background: ${(props: any) => props.theme.colors.interfacePure0};
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    transition: all 0.2s ease;
    border: none;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    @media (max-width: 1100px) {
        padding: 14px 16px 16px;
    }
    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export const TituloBloco = styled.div`
    font-size: 16px;
    color: ${({ theme }) => theme.colors.c000000};
    font-weight: 600;
    margin-bottom: 16px;
    padding-top: 10px;
    padding-bottom: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-bottom: 1px solid transparent;
    line-height: 1;
    
    svg {
        display: flex;
        align-items: center;
    }
`;

export const FlexSimplesInfoPrincipal = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    gap: 20px;

    > * {
        height: 100%;
    }


    @media (max-width: 1300px) {
        flex-direction: column;
    }
`;

export const FlexSimples = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    gap: 20px;

    > * {
        height: 100%;
    }
`;

export const ContainerDinamicoEscudeiro = styled.div<{ ehAudiencia?: boolean }>`
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    @media (min-width: 1300px) {
        display: ${({ ehAudiencia }: { ehAudiencia?: boolean }) => !ehAudiencia ? 'grid' : 'flex'};
        grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
        flex-wrap: wrap;
        gap: 20px;
        flex-direction: column;
    }
`;

export const LinhaQuebradaInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 13px;
    padding-left: 3px;
    min-width: 100px;
    flex-wrap: wrap;
    align-items: flex-start;
    .label {
        text-transform: uppercase;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        font-weight: 500;
    }
    .value {
        text-transform: capitalize;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.c000000};
        font-weight: 600;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
    }
`;

export const LinhaInfo = styled.span`
    display: flex;
    flex-direction: row;
    font-size: 12px;
    margin-bottom: 12px;
    align-items: center;
    flex-wrap: wrap;
    transition: all 0.2s ease;

    .label {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        padding-bottom: 5px;
    }
    .value {
        color: ${({ theme }) => theme.colors.c000000};
        font-weight: bold;
        white-space: pre-wrap;
        padding-left: 10px;
        padding-bottom: 5px;
        font-weight: 600;
    }
`;

export const LinhaInfoInline = styled.span`
    display: block;
    font-size: 12px;
    margin-bottom: 12px;
    transition: all 0.2s ease;
    line-height: 1.4;

    .label {
        display: inline;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        
        svg {
            display: inline;
            margin-right: 8px;
            vertical-align: middle;
        }
    }
    .value {
        display: inline;
        color: ${({ theme }) => theme.colors.c000000};
        font-weight: 600;
        padding-left: 10px;
    }
`;

export const TextoAvulso = styled.span`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    padding-bottom: 5px;
    display: block;
    font-weight: 400;
    margin-left: 20px;
`;

export const BotaoBranco = styled.button`
    width: 100%;
    height: 40px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    border: 2px solid ${({ theme }) => theme.colors.interfacePure100};
    color: ${({ theme }) => theme.colors.c000000};
    padding: 0 16px;
    font-size: 14px;
    font-weight: 600;
    transition: all .3s;

    &:hover {
        background-color: ${({ theme }) => theme.colors.interfacePure100};
        color: ${({ theme }) => theme.colors.c000000};
    }
`